import React from 'react';
interface WithNoneAuthenticationProps {
}

export default function withNonAuthentication<P extends object>(
    WrappedComponent: React.ComponentType<P>
) {
    const WithNoneAuthentication = (props: P & WithNoneAuthenticationProps): React.ReactElement => {
        return <WrappedComponent {...(props as P)} />;
    };

    return WithNoneAuthentication;
}
